@use "_abstracts" as *;

.toaster-container {
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    max-width: 400px;
    width: 100%;

    @media (max-width: 640px) {
        top: 0.5rem;
        right: 0.5rem;
        left: 0.5rem;
        max-width: none;
    }
}

.toast-item {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    background: var(--white-color);
    border: 1px solid var(--border-primary);
    border-radius: 0.75rem;
    padding: 1rem;
    box-shadow: 0 10px 25px var(--shadow);
    animation: slideIn 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
    }

    &.success {
        &::before {
            background: var(--success);
        }

        .toast-icon {
            color: var(--success);
        }
    }

    &.error {
        &::before {
            background: var(--error);
        }

        .toast-icon {
            color: var(--error);
        }
    }

    &.warning {
        &::before {
            background: var(--warning);
        }

        .toast-icon {
            color: var(--warning);
        }
    }

    &.info {
        &::before {
            background: var(--accent-primary);
        }

        .toast-icon {
            color: var(--accent-primary);
        }
    }

    .toast-icon {
        flex-shrink: 0;
        margin-top: 0.125rem;
    }

    .toast-content {
        flex: 1;
        min-width: 0;

        .toast-title {
            font-weight: 600;
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            margin-bottom: 0.25rem;
            line-height: 1.4;
        }

        .toast-description {
            color: var(--text-secondary);
            font-size: var(--font-size-s);
            line-height: 1.4;
            margin-bottom: 0;
        }

        .toast-action {
            background: none;
            border: none;
            color: var(--accent-primary);
            font-size: var(--font-size-s);
            font-weight: 500;
            cursor: pointer;
            padding: 0;
            text-decoration: underline;
            transition: color 0.2s ease;

            &:hover {
                color: var(--accent-hover);
            }
        }
    }

    .toast-close {
        flex-shrink: 0;
        background: none;
        border: none;
        color: var(--text-tertiary);
        cursor: pointer;
        padding: 0.25rem;
        border-radius: 0.25rem;
        transition: all 0.2s ease;
        margin-top: -0.25rem;
        margin-right: -0.25rem;

        &:hover {
            background: var(--bg-secondary);
            color: var(--text-secondary);
        }
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(100%);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}